import NoResultsFound from "./NoResultsFound";

export default NoResultsFound;
